<div class="purchase-success mt-5">
  <i class="fa-duotone text-5xl fa-badge-check" style="color: green;"></i>
  <span class="text-xl mt-3">
    Thank you for your purchase!
  </span>
  <p class="mt-3 text-gray-400 text-base text-center">An email has been sent with further instructions on activating your account.</p>
</div>
